import { render, staticRenderFns } from "./PorletInformes.vue?vue&type=template&id=0c52f28c"
import script from "./PorletInformes.vue?vue&type=script&lang=js"
export * from "./PorletInformes.vue?vue&type=script&lang=js"
import style0 from "./PorletInformes.vue?vue&type=style&index=0&id=0c52f28c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports